import { render, staticRenderFns } from "./OscillographyChart.vue?vue&type=template&id=ca6251a0&scoped=true&"
import script from "./OscillographyChart.vue?vue&type=script&lang=js&"
export * from "./OscillographyChart.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyChart.vue?vue&type=style&index=0&id=ca6251a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6251a0",
  null
  
)

export default component.exports